import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { LayoutComponent } from 'app/shared/components/layout/layout.component';
import { InitialDataResolver } from 'app/app.resolvers';
import { SupersetComponent } from '@shared/components/superset/superset.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    resolve: {
      initialData: InitialDataResolver,
    },
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },

      {
        path: 'home',
        loadChildren: () => import('app/features/landing/home/home.module').then(m => m.LandingHomeModule),
      },
      {
        path: 'partes',
        loadChildren: () => import('app/features/partes/partes.module').then(m => m.PartesModule),
      },
      {
        path: 'guias-transporte',
        loadChildren: () => import('app/features/guias-transporte/guias-transporte.module').then(m => m.GuiasTransporteFeatureModule),
      },
      {
        path: 'ambiente',
        loadChildren: () => import('app/features/ambiente/ambiente.module').then(m => m.AmbienteFeatureModule),
      },
      {
        path: 'pagos',
        loadChildren: () => import('app/features/pagos/pagos.module').then(m => m.PagosModule),
      },
      {
        path: 'entregas',
        loadChildren: () => import('app/features/entregas/entregas.module').then(m => m.EntregasModule),
      },
      {
        path: 'seguridad',
        loadChildren: () => import('app/features/seguridad/seguridad.module').then(m => m.SeguridadModule),
        data: { title: 'seguridad', breadcrumb: 'seguridad' }
      },
      {
        path: 'inspecciones',
        loadChildren: () => import('app/features/inspecciones/inspecciones.module').then(m => m.InspeccionesModule),
      },
      {
        path: 'recursos',
        loadChildren: () => import('app/features/recursos/recursos.module').then(m => m.RecursosModule),
      },
      {
        path: 'localidades',
        loadChildren: () => import('app/features/localidades/localidades.module').then(m => m.LocalidadesModule),
      },
      {
        path: 'empresas',
        loadChildren: () => import('app/features/empresas/empresas.module').then(m => m.EmpresasModule),
      },
      {
        path: 'explotacion',
        loadChildren: () => import('app/features/explotacion/explotacion.module').then(m => m.ExplotacionModule),
      },
      {
        path: 'contratos',
        loadChildren: () => import('app/features/contratos/contratos.module').then(m => m.ContratosModule),
        data: { title: 'contratos', breadcrumb: 'contratos' }
      },
      {
        path: 'legales',
        loadChildren: () => import('app/features/legales/legales.module').then(m => m.LegalesModule),
        data: { title: 'marcoslegales', breadcrumb: 'marcoslegales' }
      },
      {
        path: 'inversiones',
        loadChildren: () => import('app/features/explotacion/inversiones/inversiones.module').then(m => m.InversionesModule),
        data: { title: 'inversiones', breadcrumb: 'inversiones' }
      },
      {
        path: 'compre-rn',
        loadChildren: () => import('app/features/compre-rn/compre-rn.module').then(m => m.CompreRnModule),
        data: { title: 'compre-rn', breadcrumb: 'compre-rn' }
      },
      {
        path: 'pagos-refactor',
        loadChildren: () => import('app/features/pagos-refactor/pagos-refactor.module').then(m => m.PagosRefactorModule),
      },
      {
        path: 'indicadores',
        loadChildren: () => import('app/features/indicadores/indicadores.module').then(m => m.IndicadoresModule),
        data: { title: 'Indicadores', breadcrumb: 'inversiones' }
      },
      {
        path: 'regalias',
        loadChildren: () => import('app/features/regalias/regalias.module').then(m => m.RegaliasModule),
        data: { title: 'Regalias', breadcrumb: 'inversiones' }
      },
      { path: 'superset/:id',                            component: SupersetComponent },

    ],
  },
  {
    path: '',
    component: LayoutComponent,
    data: { layout: 'empty' },
    children: [
      { path: 'sign-in', loadChildren: () => import('app/features/auth/sign-in/sign-in.module').then(m => m.AuthSignInModule) },

      { path: 'sign-out', loadChildren: () => import('app/features/auth/sign-out/sign-out.module').then(m => m.AuthSignOutModule) },
    ],
  },
  {
    path: '**',
    redirectTo: 'home',
  },
];
